export const axiosMixins = {
  methods: {
    axiosMessage(error) {
      console.log(!!error);
      if (error.response) {
        // 請求成功發出，伺服器回傳狀態碼大於 2XX
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 成功發出請求，但未收到回應
        console.log(error.request);
      } else {
        // 發送請求失敗
        console.log("Error", error.message);
        console.log(error.config);
      }
    },
  }
};
